import {
  Component,
  effect,
  input,
  InputSignal,
  OnInit,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorMessageComponent } from '../../../layout/error-message/error-message.component';
import {
  ControlContainer,
  FormGroupDirective,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { FormInputComponent } from '../form-input.component';
import { ToFormControlPipe } from '../../../../pipes/to-form-control/to-form-control.pipe';
import { AppendTestIdPipe } from '../../../../pipes/append-test-id/append-test-id.pipe';

@Component({
  selector: 'aw-checkbox',
  imports: [
    CommonModule,
    ErrorMessageComponent,
    ReactiveFormsModule,
    ToFormControlPipe,
    AppendTestIdPipe,
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  templateUrl: './checkbox.component.html',
})
export class CheckboxComponent extends FormInputComponent implements OnInit {
  public readonly borderColor: InputSignal<string> = input<string>('');
  public readonly borderWidth: InputSignal<string> = input<string>('');

  public readonly valueChange: OutputEmitterRef<boolean> = output<boolean>();

  constructor(public override ngControl: NgControl) {
    super(ngControl);
  }

  ngOnInit(): void {
    this.subscription.add(
      this.ngControl.control!.valueChanges.subscribe(value => {
        this.ngControl.control!.markAsTouched();
        this.valueChange.emit(value);
      })
    );
  }

  /*
   * Necessary so clicking the label also change the controls value
   * touched needs to be set too, since type=checkbox does not propagate it properly
   * */
  public toggle(): void {
    if (this.ngControl.control && !this.ngControl.control!.disabled) {
      this.ngControl.control!.setValue(!this.ngControl.value);
      this.ngControl.control!.markAsTouched();
    }
  }
  public get checked(): boolean {
    return !!this.ngControl.value;
  }
}
